import i18n from "i18next";
import React from "react";

export function Checkbox (props) {
    const value = props.value ? "ja" : "nein";
    const className = props.value ? "CChecked" : "CUnchecked";
    return <span className={className}>{i18n.t(value)}</span>;
}
